import React, { useEffect } from "react";
import { useRecoilState } from "recoil";
import { loadingBarState } from "../store";
import styles from "./LoadingBar.module.css"; // CSS 모듈 불러오기

const LoadingBar = () => {
  const [loading, setLoading] = useRecoilState(loadingBarState);

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [loading, setLoading]);

  return loading && <div className={styles.loadingBar}></div>; // CSS 모듈 클래스 사용
};

export default LoadingBar;
